// extracted by mini-css-extract-plugin
module.exports = {"root":"TabBar-root-3HrUq","primary":"TabBar-primary-3rIQ9","secondary":"TabBar-secondary-1fJR3"};